var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slide_bar"},[_c('div',{staticClass:" bg-default autherinfo"},[_c('div',{staticClass:"topbar"},[_vm._v("作者：")]),_vm._v(" "),_c('div',{staticClass:"sidebar-info"},[_c('router-link',{attrs:{"to":{
               name:'user_info',
               params:{
                   name:_vm.userinfo.loginname,
               }
           }}},[_c('img',{attrs:{"src":_vm.userinfo.avatar_url,"alt":""}})]),_vm._v(" "),_c('router-link',{attrs:{"to":{
               name:'user_info',
               params:{
                   name:_vm.userinfo.loginname,
               }
           }}},[_c('span',[_vm._v(_vm._s(_vm.userinfo.loginname))])])],1)]),_vm._v(" "),_c('div',{staticClass:"bg-default recent_topics"},[_c('div',{staticClass:"topbar"},[_vm._v("作者最近主题：")]),_vm._v(" "),_c('ul',_vm._l((_vm.topiclimitby5),function(list){return _c('li',{key:list},[_c('router-link',{attrs:{"to":{
                       name:'post_content',
                       params:{
                           id:list.id,
                           name:list.author.loginname
                       }
                   }}},[_vm._v("\n                       "+_vm._s(list.title)+"\n                   ")])],1)}))]),_vm._v(" "),_c('div',{staticClass:" bg-default recent_replies"},[_c('div',{staticClass:"topbar"},[_vm._v("作者最近回复")]),_vm._v(" "),_c('ul',_vm._l((_vm.replylimitby5),function(list){return _c('li',{key:list},[_c('router-link',{attrs:{"to":{
                       name:'post_content',
                       params:{
                           id:list.id,
                           name:list.author.loginname
                       }
                   }}},[_vm._v("\n                       "+_vm._s(list.title)+"\n                   ")])],1)}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e56ca12","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SlideBar.vue
// module id = null
// module chunks = 